export default "__VITE_PUBLIC_ASSET__97ce6ead__"